export default "__VITE_ASSET__DQ6H5Tbf__"